const useStorage = <T extends any>() => {
	const push = (key: string, item: T) => {
		const value = JSON.stringify(item);
		sessionStorage.setItem(key, value)
	};

	const pop = (key: string): T | null => {
		const serializeItem = sessionStorage.getItem(key)
		if (serializeItem) {
			const item = JSON.parse(serializeItem);
			sessionStorage.removeItem(key);
			return item;
		}
		return null;
	};

	return {
		push,
		pop
	};
};

export default useStorage;